import { ReactElement } from 'react';
import { IMetaLocationClosedDates, IPageLocationFields } from 'types/contentful';
import OfficeLocationCard from './OfficeLocationCard';

interface DoctorLocationsAccordianProps {
  id: string;
  locations: IPageLocationFields[];
  closedDates: IMetaLocationClosedDates | undefined;
  siteName: string;
  markerIcon: string;
  factua?: boolean;
  providerId?: string;
}

export default function DoctorLocationsAccordian({
  locations,
  closedDates,
  siteName,
  id,
  markerIcon,
  factua = false,
  providerId,
}: DoctorLocationsAccordianProps): ReactElement {
  return (
    <div
      id={id}
      className="bg-muted px-site-component ecp-my py-10 md:py-20"
      style={{ scrollMarginTop: '13rem' }}
    >
      <div className="flex items-center mt-6 md:mt-0 mb-16">
        <h3 className="bordered-heading text-new-34 font-light lg:text-4xl lg:leading-new-43 text-primary-actual">
          Doctor Locations
        </h3>
      </div>
      <div className="space-y-5">
        {locations.map((x, i) => (
          <OfficeLocationCard
            location={x}
            key={i}
            index={i}
            closedDates={closedDates}
            siteName={siteName}
            markerIcon={markerIcon}
            factua={factua}
            providerId={providerId}
          />
        ))}
      </div>
    </div>
  );
}
